import { services } from "./services";
import { products } from "./products";

// Brand + contact info. Replace the placeholder contact values with real ones.
export const site = {
  name: "Visible Online",
  star: "⭐",
  tagline: "Your Business, Visible Online.",
  subTagline: "Helping Local Businesses Get Found, Trusted, and Chosen.",
  about:
    "Visible Online helps local businesses establish a strong online presence. We assist with Google Business Profile setup, professional websites, product showcases, and custom software solutions so customers can easily find and connect with your business.",
  contact: {
    phone: "+91 9679337579",
    phoneHref: "tel:+919679337579",
    email: "contact@visibleonline.in",
    emailHref: "mailto:contact@visibleonline.in",
    whatsapp: "+91 7047412047",
    whatsappHref: "https://wa.me/917047412047",
    location: "Service Available Across India",
  },
  social: {
    // Replace with your real profile URLs.
    facebook: "https://www.facebook.com/visibleonlineservices",
    instagram: "https://www.instagram.com/visibleonline.in",
  },
};

export const navLinks = [
  { label: "About", href: "/about" },
  {
    label: "Services",
    href: "/services",
    // Mega menu: one entry per service, kept in sync with src/data/services.js
    children: services.map((service) => ({
      label: service.title,
      description: service.description,
      icon: service.id,
      href: `/services#service-${service.id}`,
    })),
    footer: {
      label: "View all services",
      href: "/services",
      cta: { label: "Get a free consultation", href: "/contact" },
    },
  },
  {
    label: "Products",
    href: "/products",
    // Mega menu: one entry per digital product, kept in sync with src/data/products.js
    children: products.map((product) => ({
      label: product.name,
      description: product.tagline,
      icon: product.icon,
      href: `/products/${product.slug}`,
    })),
    footer: {
      label: "View all products",
      href: "/products",
      cta: { label: "Request a demo", href: "/contact" },
    },
  },
  { label: "Websites", href: "/websites" },
  { label: "Pricing", href: "/pricing" },
];
